import React from 'react';
import { NavLink } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';

import { transformSource } from '../../utils/helpers';

import { ROUTER_TYPES, DICTIONARIES } from '../../utils/constants';

import './Footer.sass';

import { ReactComponent as DataArtLogo } from './dataart-logo.svg';
import SocialLargeLinks from '../../uikit/SocialLargeLinks';

interface Props {
	content: {
		[keys: string]: string;
	};
}

function Footer(props: Props) {
	return (
		<footer className="footer">
			<Container>
				<Row>
					<Col xs={12} className="footer__logo">
						<a href="https://dataart.com" target="_blank" rel="noreferrer">
							<DataArtLogo />
						</a>
					</Col>
					<Col xs={12} md={6} lg={3} className="footer__info">
						<p className="uikit-text-small">
							{props.content[DICTIONARIES.footerTextUnderLogo]}
						</p>
					</Col>
					<Col
						xs={12}
						md={{ offset: 1, span: 5 }}
						lg={5}
						className="footer__nav"
					>
						<h4 className="uikit-label-small-caps">
							{props.content[DICTIONARIES.footerLinksTitle]}
						</h4>
						<nav>
							<NavLink
								className="uikit-text-small"
								to={ROUTER_TYPES.codeOfConduct}
							>
								Code of Conduct
							</NavLink>
							<NavLink className="uikit-text-small" to={ROUTER_TYPES.policy}>
								Privacy Policy
							</NavLink>
						</nav>
					</Col>
					<Col xs={12} lg={3} className="footer__contacts">
						<h4 className="uikit-label-small-caps">
							{props.content[DICTIONARIES.footerContactsTitle]}
						</h4>
						<a
							href="mailto:it-nonstop@dataart.com"
							className="uikit-heading-tiny footer__email"
						>
							it-nonstop@dataart.com
						</a>
						<div className="footer__socials">
							<SocialLargeLinks />
						</div>
					</Col>
					<Col xs={12} className="footer__copyright">
						<p className="uikit-text-small">
							{ReactHtmlParser(props.content[DICTIONARIES.copyrightFirst], {
								transform: transformSource,
							})}
							1997—
							{new Date().getFullYear()}{' '}
							{ReactHtmlParser(props.content[DICTIONARIES.copyrightSecond], {
								transform: transformSource,
							})}
						</p>
						{/* Need to always keep a current year */}
					</Col>
				</Row>
			</Container>
		</footer>
	);
}

export default Footer;
